export const DEFAULT_CURRENCY = 'USD';
export const WEB_PAYMENTS_URL =
  'https://popularpays.com/purchase/v1/popularpays_content_studio';
